import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavBadgesStore {
  readonly entreprisesEnDiscussion = signal(0);
  readonly offresAvecCandidats = signal(0);

  setEntreprisesEnDiscussion(count: number): void {
    this.entreprisesEnDiscussion.set(count);
  }

  setOffresAvecCandidats(count: number): void {
    this.offresAvecCandidats.set(count);
  }
}
